import React from 'react';
import { IonButton } from '@ionic/react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const nextLang = i18n.language === 'id' ? 'en' : 'id';
    i18n.changeLanguage(nextLang);
  };

  return (
    <IonButton onClick={toggleLanguage} color="light" size="small">
      <span style={{ fontWeight: 'bold' }}>{i18n.language === 'id' ? 'ID' : 'EN'}</span>
    </IonButton>
  );
};

export default LanguageSwitcher;
